// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___3NOD4","item":"styles__item___3TI4I"};